import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import PrivacyChecks from "@/components/PrivacyChecks";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function PrivacyAcknowledge() {
  const { actor, user, isViewAs, refresh, logout, exitViewAs } = useAuth();
  const me = actor || user;
  const [checks, setChecks] = useState({ notice: false, pbo: false });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/privacy/acknowledge", { privacy_notice: checks.notice, pbo_data_minimisation: checks.pbo });
      await refresh();
      toast.success("Thanks — acknowledgement saved");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F7F5EF] flex items-center justify-center p-5">
      <Card className="w-full max-w-lg p-6 sm:p-8 space-y-5" data-testid="privacy-ack-page">
        <div>
          <div className="text-[11px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold">Before you continue</div>
          <h1 className="font-serif text-2xl sm:text-3xl text-[#0A1F44] mt-1">Privacy acknowledgement</h1>
          <p className="text-sm text-slate-500 mt-1">Signed in as <span className="font-medium text-slate-800">{me?.email}</span>. Please confirm both statements to use Team Smith Hub.</p>
        </div>
        {isViewAs ? (
          <div className="rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="privacy-ack-view-as">
            You're in read-only View As. Acknowledgements can only be given by the person themselves — exit View As to continue.
            <Button size="sm" variant="outline" className="mt-2 block" onClick={exitViewAs} data-testid="privacy-ack-exit-view-as">Exit View As</Button>
          </div>
        ) : (
          <PrivacyChecks value={checks} onChange={setChecks} />
        )}
        <div className="flex items-center justify-between gap-3">
          <button type="button" onClick={logout} className="text-xs text-slate-500 hover:text-slate-800" data-testid="privacy-ack-signout">Sign out</button>
          {!isViewAs && (
            <Button onClick={submit} disabled={busy || !checks.notice || !checks.pbo} data-testid="privacy-ack-submit"
                    className="rounded-full bg-[#0A1F44] text-white h-11 px-6">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Continue"}
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
}
